import type { GnomuxFeature, GnomuxPrimer } from "@db/content";
import type { RestrictionEnzyme } from "restriction-enzymes";

export function filterPrimers(
  query: string,
  primers: GnomuxPrimer[] | undefined,
): GnomuxPrimer[] {
  if (!query || !primers) return [];
  return primers.filter((p) => p.name.toLowerCase().includes(query));
}

export function filterFeatures(
  query: string,
  features: GnomuxFeature[] | undefined,
): GnomuxFeature[] {
  if (!query || !features) return [];
  return features.filter((f) => f.name.toLowerCase().includes(query));
}

export function filterEnzymes(
  query: string,
  allEnzymes: RestrictionEnzyme[],
): RestrictionEnzyme[] {
  if (!query) return [];
  return allEnzymes.filter(
    (e) =>
      e.name.toLowerCase().includes(query) ||
      e.site.toLowerCase().includes(query),
  );
}
